/**
 * CCTV 관계(cctv_connections) — 조명서버가 순차 점등을 번지게 할 때 따라가는
 * 좌/우 이웃 체인. 한 행은 "name 에서 direction 쪽 depth 번째 이웃은 to".
 *
 * 스키마는 현장 router DB 의 cctv_connections 와 같다
 * (scripts/smartparking-router-schema.sql). 여기서는 맵 좌표로 관계를 만들고
 * 파일로 내보내며, DB 반영은 현장 콘솔(offline-manage)이 한다.
 */

export type CctvRelationDirection = 'left' | 'right'

export interface CctvConnection {
  /** 기준 CCTV 이름 (cctv_connections.name) */
  name: string
  /** 이웃 CCTV 이름 (cctv_connections.to_cctv_id) */
  to: string
  direction: CctvRelationDirection
  /** 항상 1 — 조명서버는 이 값을 읽기만 하고 전파 거리는 light_configs 가 정한다. */
  depth: number
}

/** 자동 생성 결과. lonely 는 이웃을 한 대도 못 찾은 카메라 수(운영자 확인용). */
export interface GeneratedRelations {
  rows: CctvConnection[]
  lonely: number
}

/** 맵에서 뽑아낸 CCTV 한 대 — 관계 도출에 필요한 건 이름과 좌표뿐이다. */
export interface RelationCamera {
  name: string
  x: number
  y: number
}

/**
 * 주차면 한 칸의 외곽 폴리곤(카메라와 같은 맵 좌표계). 자동 생성은 선분이
 * 이를 관통하는 연결을 버린다 — 건너편 통로 카메라와의 오연결 차단용.
 */
export type RelationObstacle = { x: number; y: number }[]

/** depth 상한 — 실측 체인은 한 자릿수지만 오타(100 등)를 막는다. */
export const MAX_DEPTH = 99

/** DB 컬럼과 같은 문자 집합. 이름이 이 밖이면 현장 반영 때 거부된다. */
const NAME_RE = /^[A-Za-z0-9._-]{1,64}$/

export function isValidCctvName(s: string): boolean {
  return NAME_RE.test(s)
}

export function isValidDirection(s: string): s is CctvRelationDirection {
  return s === 'left' || s === 'right'
}
